import React from 'react';
import { Row, Col, Card, Button, Badge, Alert, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useGetMyCoursesQuery } from '../slices/ordersApiSlice';
import Loader from '../components/Loader';
import Message from '../components/Message';
import { getImageUrl } from '../utils/imageUtils';
import moment from 'moment';

const MyCoursesScreen = () => {
  const {
    data: coursesData,
    isLoading,
    error,
    refetch,
  } = useGetMyCoursesQuery();

  if (isLoading) return <Loader />;

  return (
    <div>
      <div className='page-heading d-flex flex-wrap justify-content-between align-items-start gap-3 mb-4'>
        <div>
          <h1>Mes Formations</h1>
          <p>Accédez à toutes vos formations achetées</p>
        </div>
        <Button
          variant='outline-secondary'
          className='rounded-pill'
          onClick={refetch}
          disabled={isLoading}
        >
          {isLoading ? <Spinner size='sm' /> : 'Actualiser'}
        </Button>
      </div>

      {error && (
        <Message variant='danger'>
          {error?.data?.message ||
            error.error ||
            'Erreur lors du chargement des formations'}
        </Message>
      )}

      {coursesData?.courses && coursesData.courses.length === 0 ? (
        <div className='auth-panel text-center'>
          <h2>Aucune formation pour le moment</h2>
          <p className='text-muted mb-3'>
            Parcourez notre catalogue et achetez votre première formation.
          </p>
          <Link to='/online'>
            <Button className='btn-teal'>Découvrir les formations</Button>
          </Link>
        </div>
      ) : (
        <>
          <div className='admin-stat-card p-3 mb-4 text-center'>
            <h4 className='mb-1' style={{ color: 'var(--teal-dark)' }}>
              {coursesData?.count || 0}
            </h4>
            <small className='text-muted'>Formations achetées</small>
          </div>

          <Row>
            {coursesData?.courses.map((course) => (
              <Col key={course.productId} lg={6} className='mb-4'>
                <Card className='product-card h-100'>
                  <Row className='g-0 h-100'>
                    <Col md={4}>
                      <Card.Img
                        src={getImageUrl(course.product.image)}
                        alt={course.product.name}
                        className='h-100'
                        style={{ objectFit: 'cover', minHeight: 140 }}
                        onError={(e) => {
                          e.target.src = '/images/placeholder.jpg';
                        }}
                      />
                    </Col>
                    <Col md={8}>
                      <Card.Body className='d-flex flex-column h-100'>
                        <div className='flex-grow-1'>
                          <div className='d-flex justify-content-between align-items-start mb-2 gap-2'>
                            <Card.Title className='h5 mb-0'>
                              {course.product.name}
                            </Card.Title>
                            <Badge bg='success'>Achetée</Badge>
                          </div>

                          <Card.Text className='text-muted small mb-2'>
                            {course.product.description}
                          </Card.Text>

                          <div className='mb-2'>
                            <small className='text-muted'>
                              <strong>Catégorie :</strong>{' '}
                              {course.product.category}
                            </small>
                          </div>

                          <div className='mb-2'>
                            <small className='text-muted'>
                              <strong>Achetée le :</strong>{' '}
                              {moment(course.purchasedAt).format('DD MMMM YYYY')}
                            </small>
                          </div>

                          <div className='mb-3'>
                            <small className='text-muted'>
                              <strong>Prix payé :</strong> {course.product.price}{' '}
                              TND
                            </small>
                          </div>
                        </div>

                        <div className='d-flex gap-2 flex-wrap mt-auto'>
                          <Link
                            to={`/course/${course.productId}/playlists`}
                            className='flex-fill'
                          >
                            <Button className='btn-teal w-100'>
                              Accéder aux vidéos
                            </Button>
                          </Link>

                          <Link
                            to={`/product/online/${course.productId}`}
                            className='flex-fill'
                          >
                            <Button
                              variant='outline-secondary'
                              className='w-100 rounded-pill'
                            >
                              Détails
                            </Button>
                          </Link>
                        </div>
                      </Card.Body>
                    </Col>
                  </Row>
                </Card>
              </Col>
            ))}
          </Row>
        </>
      )}
    </div>
  );
};

export default MyCoursesScreen;
